'use strict';

var _classCallCheck = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var extend = require('xtend');
var SafeEventEmitter = require('safe-event-emitter');
var ObservableStore = /*#__PURE__*/function (_SafeEventEmitter) {
  _inherits(ObservableStore, _SafeEventEmitter);
  function ObservableStore() {
    var _this;
    var initState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, ObservableStore);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ObservableStore).call(this));
    // set init state
    _this._state = initState;
    return _this;
  }

  // wrapper around internal getState
  _createClass(ObservableStore, [{
    key: "getState",
    value: function getState() {
      return this._getState();
    } // wrapper around internal putState
  }, {
    key: "putState",
    value: function putState(newState) {
      this._putState(newState);
      this.emit('update', newState);
    }
  }, {
    key: "updateState",
    value: function updateState(partialState) {
      // if non-null object, merge
      if (partialState && typeof partialState === 'object') {
        var state = this.getState();
        var newState = Object.assign({}, state, partialState);
        this.putState(newState);
        // if not object, use new value
      } else {
        this.putState(partialState);
      }
    } // subscribe to changes
  }, {
    key: "subscribe",
    value: function subscribe(handler) {
      this.on('update', handler);
    } // unsubscribe to changes
  }, {
    key: "unsubscribe",
    value: function unsubscribe(handler) {
      this.removeListener('update', handler);
    } //
    // private
    //
    // read from persistence
  }, {
    key: "_getState",
    value: function _getState() {
      return this._state;
    } // write to persistence
  }, {
    key: "_putState",
    value: function _putState(newState) {
      this._state = newState;
    }
  }]);
  return ObservableStore;
}(SafeEventEmitter);
module.exports = ObservableStore;